module.exports = __webpack_public_path__ + "assets/img/defultPreviewFile.b47afa66.png";